import { graphql, useStaticQuery } from 'gatsby'

const useSiteMetadata = () => useStaticQuery(query).site.siteMetadata

export default useSiteMetadata

const query = graphql`query useSiteMetadata {
  site { siteMetadata { siteUrl } }
}`
